import { observer } from 'mobx-react-lite'
import type { TaxJobDetailsViewModel } from '@/features/jobs/details/tax-type/TaxJobDetailsViewModel'
import { PageSection } from '@/features/jobs/details/components/PageLayout'
import { SectionHeadline } from '@/components/SectionHeadline'
import { ChecklistStatusCardContainer } from '@/features/jobs/details/tax-type/info-gathering/components/ChecklistStatusCard/ChecklistStatusCardContainer'

interface ChecklistStatusSectionContainerProps {
  typeVm: TaxJobDetailsViewModel
}

/**
 * Checklist Status Section Container
 */
export const ChecklistStatusSectionContainer = observer(
  function ChecklistStatusSectionContainer({
    typeVm,
  }: ChecklistStatusSectionContainerProps) {
    const isRelevant =
      typeVm.infoGatheringVm.fetchChecklist.pending ||
      typeVm.infoGatheringVm.completion.type !== 'Empty'
    if (!isRelevant) {
      return null
    }

    return (
      <PageSection>
        <SectionHeadline
          isSkeleton={typeVm.infoGatheringVm.fetchChecklist.pending}
        >
          Your checklist
        </SectionHeadline>
        <ChecklistStatusCardContainer vm={typeVm} />
      </PageSection>
    )
  },
)
